import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StepComponent } from './step.component';

@NgModule({
  imports: [CommonModule],
  declarations: [StepComponent],
  exports: [StepComponent]
})
export class StepModule {}
